<template>
  <sw-modal :open="$attrs.open" @close="$emit('close')">
    <div class="emojis-wrapper">
      <div class="emojis-wrapper-header">
        <img
          v-for="(emoji, index) in emojiList"
          :key="emoji.label.fix"
          :src="getEmojiIcon(emoji)"
          width="24"
          @click="changeEmojiList(index)"
          class="emoji-button-header"
          :class="{'emoji-button-selected':index === currentList}"
        >
      </div>
      <span class="emoji-wrapper-title">{{getCurrentLabel}}</span>
      <div>
        <scroller direction="vertical" :maxHeight="195">
          <div class="emoji-list">
            <img
              v-for="(emoji, index) in getCurrentEmojiList"
              :key="emoji.cp"
              :src="getEmoji(emoji.cp)"
              width="24"
              @click="selectEmoji(emoji.cp)"
              class="emoji-button"
            >
          </div>
        </scroller>
      </div>
    </div>
  </sw-modal>
</template>
<script>
//////////////////////////////////////
// IMPORT
/////////////////////////////////////
import Scroller from '@/components/scroller/Scroller'
import EmojiList from '@/model/emoji/EmojiList'
import { getEmojiUrls } from '@/model/emoji/EmojiTools'
//////////////////////////////////////
// CLASS
/////////////////////////////////////
export default {
  name: 'EmojiModal',
  components: {
    Scroller
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  data() {
    return {
      emojiList: EmojiList,
      currentList: 0
    }
  },
  props: {
    editor: Object
  },
  computed: {
    getCurrentEmojiList() {
      return this.emojiList[this.currentList].emojis
    },
    getCurrentLabel() {
      return this.emojiList[this.currentList].label.fix
    }
  },
  methods: {
    getEmojiIcon(emoji) {
      return getEmojiUrls(emoji.icon.cp, 'png')
    },
    getEmoji(code) {
      return getEmojiUrls(code, 'png')
    },
    changeEmojiList(index) {
      this.currentList = index
    },
    selectEmoji(code) {
      this.editor.loadImage(getEmojiUrls(code, 'svg'))
      this.$emit('close')
    }
  },
  watch: {}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/modal/EmojiModal.vue